export default __webpack_public_path__ + "static/media/laboratorios.7210d5a4.png";